// extracted by mini-css-extract-plugin
export default {"div":"about_div__5atAp"};